import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { SeoSemArticleItemComponent } from './article-item/article-item.component';
import { AsSeenOnComponent } from './as-seen-on/as-seen-on.component';
import { HeroImageCarouselComponent } from './hero/image-carousel/image-carousel.component';
import { VideoHeroComponent } from './hero/video-hero/video-hero.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [
    AsSeenOnComponent,
    HeroImageCarouselComponent,
    SeoSemArticleItemComponent,
    VideoHeroComponent,
  ],
  exports: [
    AsSeenOnComponent,
    HeroImageCarouselComponent,
    SeoSemArticleItemComponent,
    VideoHeroComponent,
  ],
})
export class LandingPageSharedModule {}
